// Período padrão para telas sem paginação no backend: primeiro dia do mês atual até hoje,
// sempre em yyyy-MM-dd (formato nativo de <input type="date"> e aceito por LocalDate no backend).
export function primeiroDiaMesAtualIso() {
    const hoje = new Date();
    return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, "0")}-01`;
}

export function hojeIso() {
    const hoje = new Date();
    return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, "0")}-${String(hoje.getDate()).padStart(2, "0")}`;
}
